import { render, staticRenderFns } from "./fun.vue?vue&type=template&id=5b05a3e6&scoped=true&"
import script from "./fun.vue?vue&type=script&lang=js&"
export * from "./fun.vue?vue&type=script&lang=js&"
import style0 from "./fun.vue?vue&type=style&index=0&id=5b05a3e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b05a3e6",
  null
  
)

export default component.exports